<!--Sidebar-->
<app-sidebar (mouseenter)="onMouseEnter()"
	(mouseleave)="onMouseLeave()"
	id="leftSidebarMenu"
	class="pmd-sidebar sidebar-open"
	placement="left"
	[ngClass]="{'sidebar-with-brand': haveSubMenu || isInvoiceReviewPage || router.url.includes('/purchase-manager')}">
</app-sidebar>
<!-- pmd-sidebar-with-brand -->
<!--Navbar-->
<pmd-navbar class="khar_navbar navbar-expand-xl fixed-top bg-white"
	[ngClass]="{'purchase_navtop_collapse_block': haveSubMenu || isInvoiceReviewPage || router.url.includes('/purchase-manager')}"
	id="navbar">
	<app-navbar class="w-100"></app-navbar>
</pmd-navbar>
<!--/.Navbar-->

<!--Main Content Area-->

<main class="home-layout"
	[ngClass]="{'purchase_sidebar_collapse_block': haveSubMenu || isInvoiceReviewPage, 'is-purchase-manager': router.url.includes('/purchase-manager')}"
	aria-label="Main Content"
	id="mainContent">
	<!-- <button *ngIf="backLink$ | async"
			[routerLink]="backLink$ | async"
			type="button"
			size="xs"
			<i class="material-icons material-symbols-outlined pmd-icon-xs">arrow_back</i>
		</button> -->
	<!-- <p class="mb-0 fs-6 fw-semibold">{{title$ | async}}</p> -->
	<!-- <span>{{router.url}}</span>
	<span>{{(loggedinUser.isOwner || loggedinUser.isOutlet ) && !['/dashboard'].includes(router.url)}}</span> -->


	<!-- add layout-blur class when dropdown is open -->
	<div class="d-flex flex-1 w-100">
		<app-sidebar-submenu *ngIf="haveSubMenu && !isInvoiceReviewPage && !router.url.includes('/purchase-manager')"
			class="pmd-sidebar app-sidebar-profile-block"
			placement="left"></app-sidebar-submenu>
		<div class="main-block"
			[ngClass]="{'purchase-sidebar-inner_main_block': haveSubMenu && !isInvoiceReviewPage && !router.url.includes('/purchase-manager')}">
			<div *ngIf="(loggedinUser.isOwner || loggedinUser.isOutlet) && !['/dashboard'].includes(router.url) ">
				<app-breadcrumb></app-breadcrumb>
			</div>
			<app-plan-expiry-banner *ngIf="canShowInvoiceUploadLimitMessage()"
				[bannerMessage]="invoiceUploadLimitHitMessage">
			</app-plan-expiry-banner>

			<app-plan-expiry-banner *ngIf="canShowFreeTrialExpiredMessage()"
				[bannerMessage]="freeTrialEndMessage">
			</app-plan-expiry-banner>
			<div class="content_block">
				<router-outlet></router-outlet>
			</div>
		</div>
	</div>
	<footer aria-label="Footer"
		class="footer-main">
		<app-footer class="login-app-footer"></app-footer>
	</footer>
	<div pmdDropdown
		*ngIf="!authService.user.isAdmin && !authService.user.isLeadAdmin && !currentURL?.includes('/invoice/')"
		(onChange)="onOpenChange($event)"
		[autoClose]="false">
		<div class="menu pmd-floating-action dropdown-toggle"
			pmdDropdownToggle
			role="navigation">
			<button type="button"
				pmd-btn-fab
				color="dark"
				pmd-btn-raised
				class="d-flex align-items-center justify-content-center"
				size="md"
				id="exploreProductsToggleBtn">
				<i class="pmd-icon-sm"
					*ngIf="openDropFloating == 'closed'"><svg width="24"
						height="24"
						viewBox="0 0 24 24"
						fill="none"
						xmlns="http://www.w3.org/2000/svg">
						<path
							d="M21.6865 11.998C21.6865 6.64805 17.3498 2.31071 12 2.31055C6.64991 2.31055 2.3125 6.64796 2.3125 11.998C2.31266 17.3479 6.65001 21.6846 12 21.6846C17.3497 21.6844 21.6864 17.3478 21.6865 11.998ZM11.042 16.2559V11.998C11.042 11.4689 11.4709 11.04 12 11.04C12.529 11.0402 12.958 11.469 12.958 11.998V16.2559C12.9579 16.7848 12.529 17.2137 12 17.2139C11.4709 17.2139 11.0421 16.7849 11.042 16.2559ZM12.0107 6.78125L12.1084 6.78613C12.5913 6.83523 12.9686 7.24341 12.9688 7.73926C12.9688 8.23525 12.5914 8.64324 12.1084 8.69238L12.0107 8.69727H12C11.4709 8.69727 11.042 8.26838 11.042 7.73926C11.0422 7.21031 11.471 6.78125 12 6.78125H12.0107ZM23.6025 11.998C23.6024 18.406 18.408 23.6004 12 23.6006C5.59177 23.6006 0.396646 18.4061 0.396484 11.998C0.396484 5.58971 5.59167 0.394531 12 0.394531C18.4081 0.394693 23.6025 5.58982 23.6025 11.998Z"
							fill="white" />
					</svg>
				</i>
				<i class="pmd-icon-sm"
					*ngIf="openDropFloating == 'opened'">
					<svg width="16"
						height="16"
						viewBox="0 0 16 16"
						fill="none"
						xmlns="http://www.w3.org/2000/svg">
						<path
							d="M13.7828 0.871204C14.159 0.564587 14.7134 0.586302 15.0641 0.936634C15.4382 1.31078 15.4382 1.91796 15.0641 2.2921L9.35411 8.00109L15.0641 13.711L15.1305 13.7843C15.4371 14.1606 15.4147 14.7149 15.0641 15.0655C14.7134 15.4162 14.1591 15.4386 13.7828 15.1319L13.7096 15.0655L7.99962 9.35558L2.29064 15.0655L2.2174 15.1319C1.8411 15.4387 1.28587 15.4162 0.935169 15.0655C0.561437 14.6914 0.561258 14.0851 0.935169 13.711L6.64415 8.00109L0.935169 2.2921L0.869739 2.21886C0.562899 1.84256 0.584434 1.28737 0.935169 0.936634C1.2859 0.585899 1.84109 0.564364 2.2174 0.871204L2.29064 0.936634L7.99962 6.64562L13.7096 0.936634L13.7828 0.871204Z"
							fill="white" />
					</svg>
				</i>
			</button>
		</div>
		<ul id="dropdown-triggers-manual"
			*pmdDropdownMenu
			class="dropdown-menu mb-3 p-0 explore-product-panel"
			joyrideStep="thirdStep"
			[stepContent]="customContent03"
			[prevTemplate]="prevButton03"
			[nextTemplate]="nextButton03">
			<div
				class="card-header bg-info-light p-3 border-bottom d-flex justify-content-between gap-3 align-items-center">
				<h5 class="mb-0 flex-100">Explore The Product</h5>
				<div class="d-flex gap-2 align-items-center flex-1">
					<pmd-progressbar type="info"
						[value]="exploreProductPercentage"
						style="height: 10px;"></pmd-progressbar>
					<span class="text-info">{{exploreProductPercentage}}%</span>
				</div>
			</div>
			<ng-container *ngFor="let module of exploreProductModules;let i = index">
				<li class="py-3 px-3 d-flex align-items-center justify-content-between gap-5 border-bottom"
					[routerLink]="i != 1 ? module.path : null"
					(click)="i != 1 ? null : $event.preventDefault()">
					<div class="d-flex gap-2 align-items-center">
						<div class="icon-rounded">
							<svg width="15"
								height="15"
								viewBox="0 0 13 15"
								fill="none"
								xmlns="http://www.w3.org/2000/svg">
								<path [attr.d]="module.svgPath"
									fill="#1361CE" />
							</svg>
						</div>
						{{module.title}}
					</div>
					<span *ngIf="!module.isVisited"
						class="material-symbols-outlined">
						arrow_right_alt
					</span>
					<span *ngIf="module.isVisited"
						class="material-symbols-outlined text-success">
						check
					</span>
				</li>
			</ng-container>
		</ul>
		<ng-template #customContent03>
			<div class="p-4">
				<h5 class="text-dark fw-bold">3/<span class="text-desc fw-medium">4</span> Build up your knowledge
				</h5>
				<p class="fs-14 mb-1">Access all features and monitor your progress throughout each completed module.
				</p>
			</div>
		</ng-template>
		<ng-template #prevButton03>
			<button type="button"
				pmdRipple
				pmd-btn-outline
				color="dark"
				class="w-100">Back</button>
		</ng-template>
		<ng-template #nextButton03>
			<button type="button"
				pmdRipple
				pmd-btn
				color="secondary"
				class="w-100">Next</button>
		</ng-template>
	</div>
	<app-confirm-detail-modal *ngIf="isModalOpen"></app-confirm-detail-modal>
</main>